import TextEditing from './TextEditing';
import './style/index.less';

export default TextEditing;
